import { useEffect, useState } from 'react'
import { ResponsiveObject, Settings } from 'react-slick'

// Could not calculateVisibleSlides to work for CardGroup carousels
// This is being used to retrieve the responsive slidesToShow value
// and determine if we should render our custom next and prev buttons
export function useResponsiveSlidesToShow(base: number, responsive: ResponsiveObject[] = []) {
  const [slidesToShow, setSlidesToShow] = useState(base)

  useEffect(() => {
    function update() {
      const width = window.innerWidth
      let current = base
      responsive.forEach(r => {
        if (width <= r.breakpoint && r.settings !== 'unslick') {
          const settings = r.settings as Settings
          if (typeof settings.slidesToShow === 'number') {
            current = settings.slidesToShow
          }
        }
      })
      setSlidesToShow(current)
    }

    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [base, responsive])

  return slidesToShow
}
